import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SidebarService {
  
  isToggled: Subject<boolean>;

  constructor() { this.isToggled = new Subject() }
}